import { Entity, EntityMap } from '../types';

export enum DismissablePromptKey {
  AnnouncementTeachingBubble = 'AnnouncementTeachingBubble',
  DarkModeTeachingBubble = 'DarkModeTeachingBubble',
  FirstRunExperience = 'FirstRunExperience',
  FirstRunExperienceEditAttachments = 'FirstRunExperienceEditAttachments',
  FirstRunExperienceStoryline = 'FirstRunExperienceStoryline',
  FirstRunExperienceStorylineInVivaEngage = 'FirstRunExperienceStorylineInVivaEngage',
  FirstRunExperienceStories = 'FirstRunExperienceStories',
  FirstRunExperienceReplyUpvote = 'FirstRunExperienceReplyUpvote',
  FirstRunExperienceTopics = 'FirstRunExperienceTopics',
  InclusiveReactions = 'InclusiveReactions',
  LightboxFollowUsers = 'LightboxFollowUsers',
  LightboxJoinGroups = 'LightboxJoinGroups',
  MobileUpsell = 'MobileUpsell',
  MomentsOnboardingThumbnail = 'MomentsOnboardingThumbnail',
  PushNotifications = 'PushNotifications',
  PWAInstall = 'PWAInstall',
  StorylineDigestCoachingBar = 'StorylineDigestCoachingBar',
  StorylineAnnouncementTeachingBubble = 'StorylineAnnouncementTeachingBubble',
  VivaEngageFRE = 'VivaEngageFRE',
  VivaEngageInOutlookFRE = 'VivaEngageInOutlookFRE',
  VivaEngageRebrandingBanner = 'VivaEngageRebrandingBanner',
}

export interface DismissablePrompt extends Entity {
  readonly isDismissed: boolean;
}

export type DismissablePrompts = EntityMap<DismissablePrompt>;
